<template>
    <card-grid-item
        :tab-widget="tabWidget"
        :card-class="['card-grid']"
        :min-w="3"
        :min-h="minHeight"
        :resized="handleResized"
        @tab-widget-settings-click="handleTabWidgetSettingsClick"
    >
        <template v-slot:card-title>
            {{ title }}
            <responsive-button variant="primary" class="ml-3" :icon="['fas', 'plus']" @click="showAddNoteModal"
                >Add Note</responsive-button
            >
        </template>

        <template v-slot:card-body>
            <card-grid
                v-if="ready"
                ref="notesGrid"
                :button-toolbar-class="[]"
                :is-search="false"
                :key="cardGridKey"
                :pagination="true"
                :fetchCallback="gridFetchCallback"
                :onCellClicked="showEditNoteModal"
                :columnDefs="columnDefs"
                :pagination-page-size="limit"
                :cache-block-size="limit"
            >
            </card-grid>
            <create-edit-note-modal
                :initialValues="initialValues"
                :modalId="modalId"
                :modalTitle="modalTitle"
                @submit="createUpdateNote"
            />
        </template>

        <template v-slot:tab-widget-settings-modal>
            <tab-widget-settings-modal-form
                :modal-id="tabWidgetSettingsModalID"
                :update="updateTabWidgetSettings"
                :initial-values="tabWidgetSettingsInitialValues"
                @success-update="handleSuccessTabWidgetSettingsUpdate"
            ></tab-widget-settings-modal-form>
        </template>
    </card-grid-item>
</template>

<script>
    import API from '../../../../api';
    import CardGrid from '../../../generic/card-grid/card-grid.vue';
    import CardGridItem from '../common/card-grid-item.vue';
    import CreateEditNoteModal from './create-edit-note-modal.vue';
    import ActionsCellRenderer from './actions-cell-renderer.vue';
    import {
        DASHBOARD_NOTE_WIDGET_CREATE_NOTE_ENDPOINT,
        DASHBOARD_NOTE_WIDGET_LIST_ENDPOINT,
        DASHBOARD_NOTE_WIDGET_UPDATE_DELETE_ENDPOINT,
    } from '../../../../endpoints';
    import formInput from '../../../generic/form-input/form-input.vue';
    import FormTextarea from '../../../generic/form-textarea/form-textarea.vue';
    import { getWidgetGridRowsNumber } from '../helpers';
    import Modal from '../../../generic/modal/modal.vue';
    import ResponsiveButton from '../../../generic/responsive-button/responsive-button.vue';
    import TabWidgetSettingsModalForm from '../common/tab-widget-settings-modal-form.vue';
    import cardGridItemBaseMixin from '../common/card-grid-item-base-mixin';

    export default {
        name: 'NoteListCardGridItem',
        mixins: [cardGridItemBaseMixin],
        components: {
            Modal,
            CardGrid,
            CardGridItem,
            formInput,
            FormTextarea,
            ResponsiveButton,
            CreateEditNoteModal,
            TabWidgetSettingsModalForm,
            actionsCellRenderer: ActionsCellRenderer,
        },
        data() {
            return {
                columnDefs: [
                    {
                        field: 'entered_date',
                        type: 'dateTimeColumn',
                        headerName: 'Entered date',
                        minWidth: 190,
                        maxWidth: 190,
                        sort: 'desc',
                    },
                    {
                        field: 'title',
                        headerName: 'Title',
                        minWidth: 175,
                        maxWidth: 240,
                    },
                    {
                        field: 'content',
                        headerName: 'Content',
                        minWidth: 175,
                    },
                    {
                        field: '',
                        headerName: '',
                        minWidth: 80,
                        maxWidth: 80,
                        sortable: false,
                        cellRenderer: 'actionsCellRenderer',
                        cellRendererParams: {
                            update: () => {
                                this.$refs.notesGrid.refreshDataSource();
                            },
                        },
                        cellClass: "arrivals-actions"
                    },
                ],

                offset: 0,
                limit: getWidgetGridRowsNumber({ tabWidget: this.tabWidget }),
                sort: 'entered_date',
                desc: false,
                search: '',
                modalId: null,
                initialValues: null,
            };
        },
        methods: {
            handleResized() {
                this.limit = getWidgetGridRowsNumber({
                    tabWidget: this.tabWidget,
                });
                this.cardGridKey += 1;
            },
            showAddNoteModal() {
                this.modalId = 'add-note-modal';
                this.initialValues = null;
                this.$nextTick(() => {
                    return this.$bvModal.show(this.modalId);
                });
            },
            showEditNoteModal({ column, data }) {
                if (['title', 'content'].includes(column.colId)) {
                    this.initialValues = { ...data };
                    this.modalId = `edit-note-modal` + data.id;
                    this.$nextTick(() => {
                        return this.$bvModal.show(this.modalId);
                    });
                }
            },
            async createUpdateNote(value) {
                try {
                    this.modalId === 'add-note-modal'
                        ? await API.post(
                              DASHBOARD_NOTE_WIDGET_CREATE_NOTE_ENDPOINT(),
                              value
                          )
                        : await API.patch(
                              DASHBOARD_NOTE_WIDGET_UPDATE_DELETE_ENDPOINT(
                                  value.id
                              ),
                              value
                          );
                    this.$bvModal.hide(this.modalId);
                    this.$refs.notesGrid.refreshDataSource();
                } catch (e) {
                    this.errorToast({ text: 'Could not save data' });
                }
            },
        },
        computed: {
            modalTitle() {
                return this.modalId === 'add-note-modal' ? 'Add Note' : 'Edit Note';
            },
            gridFetchCallback() {
                return ({ offset, limit, sort, desc, search }) => {
                    this.offset = offset;
                    this.limit = limit;
                    this.sort = sort;
                    this.desc = desc;
                    this.search = search;
                    return API.get(DASHBOARD_NOTE_WIDGET_LIST_ENDPOINT(), {
                        params: {
                            offset,
                            limit,
                            sort,
                            desc,
                            search,
                        },
                    });
                };
            },
        },
    };
</script>
